function getLangShortcut(lang) {
  switch (lang) {
    case 'sv-se':
    case 'sv':
      return 'sv';
    case 'en-gb':
    case 'en-us':
    case 'en':
      return 'en';
    case 'no':
      return 'no';
    case 'da-dk':
    case 'da':
    case 'dk':
      return 'dk';
    case 'de-de':
    case 'de':
      return 'de';
    default:
      return 'sv';
  }
}

exports.linkResolver = (doc) => {
  const lang = getLangShortcut(doc.lang);
  const uid = doc.uid || '';

  if (doc.type === 'landingpage') {
    return `/${lang}/`;
  }

  return `/${lang}/${uid}`;
};
